'use client';

import { NotFoundPage } from '@ianesthesie-kit/common-pages';
import { DecorativeImage } from '@ianesthesie-kit/core';
import NotFoundImg from '../public/notfound.png';
import { ThemeProvider } from '@/containers';
import CssBaseline from '@mui/material/CssBaseline';

const Page404 = () => (
  <ThemeProvider>
    <CssBaseline />
    <NotFoundPage>
      <DecorativeImage src={NotFoundImg} alt="not found illustration" />
    </NotFoundPage>
  </ThemeProvider>
);

export default Page404;
